
import React, { useState } from 'react';
import './LocationSelector.css';
import useSound from 'use-sound';
import selected from './../../sounds/selected.wav';

const LocationSelector = ({setSelectedCity, selectedCity, isSound}) => {
    const [location, setLocation] = useState(selectedCity);
    const [selectedSound] = useSound(selected, { volume: 0.4 });

    const handleSubmit = (e) => {
        setLocation(e.target.value)
        setSelectedCity(e.target.value)
        isSound && selectedSound();
    }


    return (
        <form className="location-form">
            <label>
                <select value={location} onChange={handleSubmit} className="location-selector-button">
                    <option value="berlin">Berlin</option>
                    <option value="munich">Munich</option>
                    <option value="leipzig">Leipzig</option>
                    <option value="hamburg">Hamburg</option>
                </select>
            </label>
        </form>
    )

}

export default LocationSelector;